/**
 * construirProcessedData.ts — `C0-c` (24-oct-2026)
 *
 * Cierra OBS-P2-LO-QUE-SE-CORRIGE-EN-P2-TRAS-PASAR-POR-P3-NO-LLEGA-A-P4.
 *
 * - `construirProcessedData`: la única construcción de lo que P3 coteja y P4
 *   exporta a partir de las filas de P2 (antes, dos bloques casi idénticos en
 *   `WizardPageV2`: la flecha y el «Continuar» retirado). La flecha de P2 la
 *   llama siempre, no solo la primera vez (DOP-1 b).
 * - `huellaCotejo`: lo que el emparejamiento lee de cada fila (`MatchingEngine`:
 *   nombre, tipo, X/Y y parcela). El cotejo se rehace cuando cambia la huella,
 *   no solo al cambiar de documento (DOP-3 a). Confirmar solo cambia la
 *   puntuación de la fila, que no interviene en el emparejamiento: no lo rehace.
 */

import type { ProcessingComplete } from '../Step2'
import type { ProcessedInfrastructure } from '../../types/processing'

export function construirProcessedData(
  infras: ProcessedInfrastructure[],
  metadata: ProcessingComplete['metadata'],
): ProcessingComplete {
  return {
    infrastructures: infras,
    metadata,
    stats: {
      total: infras.length,
      normalized: infras.filter(i => i.status !== 'pending').length,
      // OBS-FN-02-A: «geocoded» significa «fila resuelta»: incluye status ∈
      // {geocoded, manual, original}. manual cubre REVISION_MANUAL (coords del
      // documento conservadas, score 30); original cubre VALIDADO (<25 m).
      geocoded: infras.filter(i => i.status === 'geocoded' || i.status === 'manual' || i.status === 'original').length,
      failed: infras.filter(i => i.status === 'pending').length,
      avgScore: infras.length > 0
        ? Math.round(infras.reduce((s, i) => s + (i.score ?? 0), 0) / infras.length)
        : 0,
    },
  }
}

export function huellaCotejo(infras: readonly ProcessedInfrastructure[]): string {
  return JSON.stringify(
    infras.map(i => [i.id, i.nombre, i.tipo, i.xFinal ?? null, i.yFinal ?? null, i.catastroParcel ?? null]),
  )
}
